import { bcSessionKeys } from 'common/common/constants/session-keys';
import { Injectable } from '@angular/core';
import { reduce } from 'lodash';
import { BcRestApi } from 'common/api/rest-api';
import { CoolSessionStorage } from '@angular-cool/storage';
import { bcEnums } from 'common/common/constants/boldchat-enums';

@Injectable()
export class ServiceEvaluatorService {

  constructor(private _sessionStorage: CoolSessionStorage, private bcRestApi: BcRestApi) {
  }

  isServiceEnabled(serviceType: number) {
    const services = this._getServicesFromSessionStorage();
    const plan = services && services[serviceType];

    return !!plan && plan !== bcEnums.servicePlanTypes.HIDDEN;
  }

  private _getServicesFromSessionStorage() {
    return this._sessionStorage.getObject(bcSessionKeys.storage.services);
  }

  getServices() {
    return this.bcRestApi.getServicePlanTypesForAllServices().then(rawServices => {
      return this._sessionStorage.setObject(bcSessionKeys.storage.services, this._createPermissionMap(rawServices));
    });
  }

  setServiceAccess(user) {
    const serviceAccess = user && user.serviceAccess ? user.serviceAccess : [];
    this._sessionStorage.setObject(bcSessionKeys.storage.serviceAccess, serviceAccess);
  }

  private _createPermissionMap(rawServices) {
    return reduce(rawServices, (result, value) => this._mapSinglePermissionItem(result, value), {});
  }

  private _mapSinglePermissionItem(result, value) {
    result[value.serviceTypeId] = value.servicePlanType;

    return result;
  }

  hasAccessForService(serviceType: number) {
    const serviceAccess = this._getServiceAccessFromSessionStorage();
    const foundAccess = serviceAccess.find(value => value === serviceType);

    return !!(serviceAccess && foundAccess === serviceType);
  }

  private _getServiceAccessFromSessionStorage() {
    return this._sessionStorage.getObject<Number[]>(bcSessionKeys.storage.serviceAccess);
  }
}
